export const store="stor"